// Angular Imports
import { Component, Inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar'
// Shared Imports
import { ISnackbarData, ESnackbarType } from '@shared/models'

@Component({
	selector: 'app-snackbar',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './snackbar.component.html',
	styleUrls: ['./snackbar.component.scss'],
})
export class SnackbarComponent {
	readonly ESnackbarType = ESnackbarType

	constructor(@Inject(MAT_SNACK_BAR_DATA) public data: ISnackbarData) {}
}
